import i18n from '@/vue-app/plugins/i18n';

export default class AllianzProcessManualReviewRequestSentViewModel {
  private readonly i18n_namespace = 'components.contract-savings.allianz.allianz-process-manual-review-request-sent';

  translate = (value: string) => (
    i18n.t(`${this.i18n_namespace}.${value}`) as string
  )
}
